import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {FC} from 'react'
import {RatiosSummaryStay} from '../RatiosSummaryStay'

const HeaderRatioSummaryStayPanel: FC = () => {
  return (
    <>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Resumen de Estadía</Tab>
          </TabList>
          <TabPanel>
            <RatiosSummaryStay />
          </TabPanel>
        </Tabs>
      </div>
    </>
  )
}

export {HeaderRatioSummaryStayPanel}
